import { IconButton } from "@material-ui/core";
import React, { useState } from "react";
import { Form, Table, Image } from "react-bootstrap";
import { TextField, FormControl, Select, InputLabel } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import BasicPagination from "../../../Pagination/Pagination";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";

function SuperAdminInvoices(props) {
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [page, setPage] = useState(1);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    let calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
    //page = pageNo;
  };
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="left-side-panel">
          <LeftSideNavigation displayLink={1} />
        </div>
        <div className="super-admin-right-side-panel">
          <HomeReusableTopBarNavigation />
          <div className="super-admin-inside-right-side-panel">
            <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
              <div className="f24_700_HelveticaNeue">Invoices</div>
            </div>
            <div className="row">
              <div className="col-3">
                <Form.Control
                  type="text"
                  placeholder="Search"
                  // onChange={props.onChange}
                  // value={props.search}
                  className="amSearch"
                />
              </div>
              <div className="col-5"></div>
              <div className="col-4">
                <div className="d-flex justify-content-end align-items-center">
                  <div className="text-blue f15-500 mr-3">Sort by</div>
                  <FormControl variant="filled" className="enSortSelect">
                    <Select
                      //   value={props.sortBy}
                      //   onChange={props.handleChangeCode}
                      inputProps={{
                        name: "SortBy",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="namea-z">Name A-Z</option>
                      <option value="namez-a">Name Z-A</option>
                    </Select>
                  </FormControl>

                  <div className="text-blue f15-500 ml-5 mr-3">Filters</div>
                  <IconButton
                    className="enDownIcon"
                    // onClick={props.handleShowFilter}
                  >
                    <Image
                      src={require("../../../../assets/images/UserManagement/chevron-down.svg")}
                      alt="View"
                      title="View"
                    />
                  </IconButton>
                </div>
              </div>
            </div>
            <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
              <Table className="HideShowTable enMinWidth900">
                <thead>
                  <tr className="super_admin_all_users_table_head">
                    <th style={{ width: "9%" }} className="f12-700">
                      Invoice
                      <br />
                      ID
                    </th>
                    <th style={{ width: "9%" }} className="f12-700">
                      Date
                    </th>
                    <th style={{ width: "9%" }} className="f12-700">
                      Request
                      <br />
                      ID
                    </th>
                    <th style={{ width: "10%" }} className="f12-700">
                      Request
                      <br />
                      Date
                    </th>
                    <th style={{ width: "9%" }} className="f12-700">
                      User
                    </th>
                    <th style={{ width: "9%" }} className="f12-700">
                      Vendor Name
                    </th>
                    <th style={{ width: "9%" }} className="f12-700">
                      Request Type
                    </th>
                    <th style={{ width: "9%" }} className="f12-700">
                      Order Total
                    </th>
                    <th style={{ width: "10%" }} className="f12-700">
                      Status
                    </th>
                    <th style={{ width: "18%" }} className="f12-700">
                      Action
                    </th>
                  </tr>
                </thead>

                {[0, 1].map((transaction, index) => (
                  <tbody key={index}>
                    <tr className="super_admin_all_users_table_body">
                      <td style={{ width: "9%" }}>
                        <div className="f12-400 text-break">101</div>
                      </td>
                      <td style={{ width: "9%" }}>
                        <div className="f12-400 text-break">XXXXXX</div>
                      </td>
                      <td style={{ width: "9%" }}>
                        <div className="f12-400">101</div>
                      </td>
                      <td style={{ width: "10%" }}>
                        <div className="f12-400">XXXXXX</div>
                      </td>
                      <td style={{ width: "9%" }}>
                        <div className="f12-400">Ryan DiMascio</div>
                      </td>
                      <td style={{ width: "9%" }}>
                        <div className="f12-400 text-break">
                          <Image src="" width="75px" />
                          <br />
                          McDonald
                        </div>
                      </td>
                      <td style={{ width: "9%" }}>
                        <div className="f12-400">Take Away</div>
                      </td>
                      <td style={{ width: "9%" }}>₹ 50</td>
                      <td style={{ width: "10%" }}>
                        <div className="f12-400 text-break">
                          <div className={`${"enSuccessLBL"}`}>Paid</div>
                        </div>
                      </td>
                      <td style={{ width: "18%" }}>
                        <div className="d-flex align-items-center">
                          <div className="f12-400">Print</div>
                          <div className="f12-400">Download</div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </Table>
            </div>
            {[0, 1].length > 1 ? (
              <BasicPagination
                totalRecords={3}
                limit={10}
                batch={page}
                onBatchChange={(e) => handleBatchChange(e)}
              />
            ) : (
              <> </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuperAdminInvoices;
